<template>
  <div class="ams">
    <div class="ams-content">
      <div class="module-1">
        <p class="title">MPCI发送</p>
        <p class="text">周末及节假日均可发送</p>
        <span class="btn" @click="openQQ">开通咨询</span>
      </div>
      <div class="module" :class="`module-${item.index}`" v-for="(item, i) in module" :key="i">
        <div class="content">
          <p class="title">{{ item.title }}</p>
          <span class="text" v-html="item.content" />
        </div>
      </div>
      <div class="module-explain">
        <div class="nav">如何发送MPCI？</div>
        <div class="explain-box">
          <div :class="`explain-box-${item.type}`" v-for="(item, i) in explain" :key="i">
            <img class="number-icon" :src="item.numUrl" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="text" v-html="item.text"></div>
          </div>
        </div>
      </div>
      <ContactUs />
    </div>
  </div>
</template>
<script>
import ContactUs from '@/components/ContactUs'
import { openQQ } from '@/utils/common.js'
import { ossUrl } from '@/utils/config.js'

export default {
  name: 'mpci',
  components: { ContactUs },
  data() {
    return {
      module: [
        // {
        //   index: 2,
        //   title: '发送0门槛',
        //   content: '发送0门槛，申报状态自动匹配，海关通知精确预警'
        // },
        // {
        //   index: 3,
        //   title: '高效录单 快速回执',
        //   content: '支持多种录单模式，「在线录单」、「Excel模版导入」助力企业降本增效；'
        // }
        // {
        //   index: 4,
        //   title: '专属客服 专业服务',
        //   content: '专业值班客服人员在线答疑，安全有保障，基础内容自动校验，降低失误率～'
        // }
      ],
      explain: [
        {
          type: 'one',
          numUrl: `${ossUrl}/common/introduce/number-1.png`,
          title: '注册账户',
          text: '微信扫码注册/手机号验证码注册/手机号密码注册，联系你的专属销售，一键开通'
        },
        {
          type: 'two',
          numUrl: `${ossUrl}/common/introduce/number-2.png`,
          title: '企业认证',
          text: '录入企业名称，上传营业执照，完成企业认证'
        },
        {
          type: 'three',
          numUrl: `${ossUrl}/common/introduce/number-3.png`,
          title: '产品权限开通',
          text: '签署数据发送协议，客服审核通过后，即可开通产品权限'
        },
        {
          type: 'four',
          numUrl: `${ossUrl}/common/introduce/number-4.png`,
          title: '预充值在使用',
          text: '预充值U币， <br /> 即可发送MPCI'
        }
      ]
    }
  },
  methods: {
    openQQ
  }
}
</script>
<style lang="scss" scoped>
.ams {
  width: 100vw;
  overflow-x: hidden;

  .ams-content {
    width: 100%;
    min-width: 1920px;
    margin-left: 50%;
    transform: translateX(-50%);
  }

  .module-1 {
    height: 1080px;
    margin: -60px auto 0;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/mpci-module-1.png');
    background-size: 100%;
    background-repeat: no-repeat;
    text-align: center;

    .title {
      font-size: 68px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #212450;
      line-height: 95px;
      letter-spacing: 1px;
      padding-top: 118px;
    }

    .text {
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #212450;
      line-height: 35px;
      letter-spacing: 3px;
      padding-top: 16px;
    }

    .btn {
      width: 180px;
      height: 64px;
      display: block;
      background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/btn.png');
      background-size: 100%;
      margin: 24px auto 0;
      line-height: 64px;
      font-weight: 600;
      color: #ffffff;
      font-size: 24px;
      cursor: pointer;
    }
  }

  .module {
    margin: 120px auto 0;
    background-repeat: no-repeat;

    .content {
      .title {
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #212450;
        line-height: 45px;
        letter-spacing: 1px;
      }

      .text {
        display: inline-block;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
        padding-top: 24px;
        text-align: justify;
      }
    }
  }

  .module-2 {
    height: 690px;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/ics-module-2.png');
    background-size: 1406px 690px;
    background-position: 251px;

    .content {
      padding: 240px 0 0 360px;

      .text {
        display: inline-block;
        width: 372px;
        letter-spacing: 1px;
      }
    }
  }

  .module-3 {
    height: 690px;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/ics-module-3.png');
    background-size: 1298px 690px;
    background-position: 308px;

    .content {
      float: right;
      padding: 311px 394px 0 0;

      .text {
        display: inline-block;
        width: 326px;
        letter-spacing: 1px;
      }
    }
  }

  .module-4 {
    height: 690px;
    background-image: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/introduce/afr-module-4.png');
    background-size: 1378px 690px;
    background-position: 250px;

    .content {
      padding: 258px 0 0 382px;

      .text {
        width: 346px;
        font-size: 22px;
        letter-spacing: 1px;
      }
    }
  }

  .module-explain {
    width: 1180px;
    margin: 119px auto 0;

    .nav {
      text-align: center;
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 45px;
      letter-spacing: 2px;
    }

    .explain-box {
      width: 100%;
      margin-top: 48px;
      display: flex;
      justify-content: space-between;

      & > div {
        width: 280px;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 34px 34px 30px;
        color: white;
        height: 300px;

        .number-icon {
          width: 49px;
          height: 49px;
        }

        .title {
          font-size: 24px;
          padding-top: 16px;
        }

        .text {
          padding-top: 9px;
          font-size: 18px;
          line-height: 25px;
          letter-spacing: 1px;
        }
      }

      .explain-box-one {
        background: #3371ff;
      }

      .explain-box-two {
        background: #0ddabe;
      }

      .explain-box-three {
        background: #ffb817;
      }

      .explain-box-four {
        background: #9517ff;
      }
    }
  }
}
</style>
